<script type="text/ecmascript-6">
  import {mapGetters} from "vuex";

  export default {
    name: 'App',

    data: () => ({
      app_version: 0.1,
    }),

    /**
     * Computed these properties.
     */
    computed: {
      ...mapGetters({
        isLoading: 'getIsLoading',
        isShow: 'getIsShow',
        dateTime: 'getDateTime',
        isFirstLoaded: 'getIsFirstLoaded',
        ownPage: 'getOwnPage',
      })
    },

    async mounted() {
      if (!this.isFirstLoaded) {
        await this.$store.dispatch('setIsLoading',true);
        await this.getMonitoredProfiles();
        await this.getBenchmarkData(this.ownPage);
        await this.$store.dispatch('setIsLoading',false);
        await this.$store.dispatch('setIsShow',true);
        await this.$store.dispatch('setIsFirstLoaded',true);
      }
    },
  }
</script>

<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>
